module.exports = __webpack_public_path__ + "img/ep-bouche.057eab24.jpg";